module.exports = __webpack_public_path__ + "img/Attack_utimate ice dragon.6db8bba8.png";